import { useFrame } from '@react-three/fiber'
import { useRef, type ReactNode } from 'react'
import type { Group } from 'three'

/** Aproximação ilustrativa do receptor; a posição final continua sendo a avaliada. */
export function ReceptorAnimado3D({ posicao, animar, pausado, children }: {
  posicao: readonly [number, number]; animar: boolean; pausado: boolean; children: ReactNode
}) {
  const grupo = useRef<Group>(null)
  const tempo = useRef(animar && !pausado ? 0 : 1)
  useFrame((_, delta) => {
    if (!pausado) tempo.current = Math.min(1, tempo.current + delta / 2.5)
    if (grupo.current) grupo.current.position.z = posicao[1] + (animar ? 18 * (1 - tempo.current) ** 2 : 0)
  })
  return <group ref={grupo} position={[posicao[0], 0, posicao[1] + (animar && !pausado ? 18 : 0)]}>{children}</group>
}
